import appConfig from '../config/AppConfig'

export const API_URLS = {
  base: appConfig.apiBaseUrl,
  local: appConfig.apiLocalUrl,
  admin: appConfig.apiAdminUrl,
  health: appConfig.getApiEndpoint('/health'),
  message: appConfig.getApiEndpoint('/message'),
  resetContext: (phone: string) => appConfig.getApiEndpoint(`/reset-context/${phone}`),
  prompts: {
    list: appConfig.getAdminEndpoint('/prompts'),
    create: appConfig.getAdminEndpoint('/prompts'),
    update: (id: number) => appConfig.getAdminEndpoint(`/prompts/${id}`),
    delete: (id: number) => appConfig.getAdminEndpoint(`/prompts/${id}`),
    duplicate: (id: number) => appConfig.getAdminEndpoint(`/prompts/${id}/duplicate`),
    preview: appConfig.getAdminEndpoint('/prompts/preview'),
    variables: appConfig.getAdminEndpoint('/prompts/variables')
  },
  agents: {
    list: appConfig.getAdminEndpoint('/agents'),
    create: appConfig.getAdminEndpoint('/agents'),
    update: (id: number) => appConfig.getAdminEndpoint(`/agents/${id}`),
    delete: (id: number) => appConfig.getAdminEndpoint(`/agents/${id}`)
  }
}

export const DEFAULT_TIMEOUT = 30000

export const MESSAGE_TYPES = {
  USER: 'user',
  BOT: 'bot',
  SYSTEM: 'system',
  PROACTIVE: 'proactive'
} as const

export const AGENT_TABS = {
  LIST: 'list',
  CREATE: 'create',
  EDIT: 'edit'
} as const

export const PROMPT_TABS = {
  LIST: 'list',
  CREATE: 'create',
  EDIT: 'edit',
  PREVIEW: 'preview'
} as const
